import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LoginService } from './login.service';

@Injectable({ providedIn: 'root' })
export class AlreadyLoggedInGuard implements CanActivate {
  constructor(private login: LoginService, private router: Router) {}

  canActivate(): boolean {
    if (!this.login.loggedIn()) return true;

    const repId = localStorage.getItem('repId') || '';
    this.router.navigateByUrl('shop/from/' + repId);
    return false;
  }
}
